import React from 'react';
import {
  RadioOptionLabel,
  RadioButton,
  RadioInput,
} from 'src/components/Input/RadioInput/RadioInput.style';
import { IRadioInputProps } from 'src/components/Input/RadioInput/RadioInput.i';

export const RadioInputOption = ({
  className,
  value,
  onChange,
  name,
  checked,
  disabled,
  children,
}: IRadioInputProps) => {
  return (
    <RadioOptionLabel htmlFor={`radio_${name}_${value}`} disabled={disabled} className={className}>
      <RadioInput
        type='radio'
        name={name}
        id={`radio_${name}_${value}`}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <RadioButton checked={checked} disabled={disabled} />
      {children}
    </RadioOptionLabel>
  );
};
